export default __webpack_public_path__ + "static/media/prosthesis.432429e3.svg";